<div class="folder-tree-icon">
    <uvx-icon>{{open ? 'chevron_top' : 'chevron_bottom'}}</uvx-icon>
    <uvx-icon>{{open ? 'folder_opened' : 'folder'}}</uvx-icon>
</div>